import { render, staticRenderFns } from "./ModalValidateComponent.vue?vue&type=template&id=78a526fa"
import script from "./ModalValidateComponent.vue?vue&type=script&lang=js"
export * from "./ModalValidateComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalValidateComponent.vue?vue&type=style&index=0&id=78a526fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports